import React from 'react';
import { motion } from 'framer-motion';
import { Skull } from 'lucide-react';
export const Problem = () => {
  return <section className="py-16 md:py-24 relative bg-black" data-id="element-150">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-red/10 via-black to-black" data-id="element-151"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-153">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-brand-red/10 mb-5 md:mb-6" data-id="element-154">
            <Skull className="w-7 h-7 md:w-8 md:h-8 text-brand-red" data-id="element-155" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl text-white mb-6 md:mb-8 px-2" data-id="element-156">
            EL VERDADERO ASESINO DE CUENTAS
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-157">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-5 md:space-y-6 text-base md:text-lg text-gray-400" data-id="element-158">
            <p data-id="element-159">
              La mayoría de los traders{' '}
              <strong className="text-white" data-id="element-160">
                no pierden su cuenta por un mal análisis técnico
              </strong>
              . La pierden por lo que hacen los 10 minutos después de una
              pérdida grande.
            </p>
            <p data-id="element-161">
              El cerebro entra en modo supervivencia. El cortisol anula tu
              lógica. Sientes que el mercado te "debe" algo y tu mano busca
              desesperadamente el botón de compra para "recuperar" lo perdido.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-surface p-6 md:p-8 border border-brand-red/20 rounded-lg" data-id="element-162">
            <h3 className="font-mono text-brand-red mb-3 md:mb-4 uppercase tracking-wider text-xs md:text-sm" data-id="element-163">
              Resultado Inevitable
            </h3>
            <p className="text-lg md:text-xl text-white font-medium italic" data-id="element-164">
              "Es un suicidio financiero lento y doloroso que termina siempre de
              la misma forma: con la cuenta en cero y una sensación de vacío
              insoportable."
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
};